<template>
  <div>
    <div
      :class="$vuetify.breakpoint.mobile ? 'mx-6' : 'mx-8'"
      class="d-flex my-2"
    >
      <img
        :class="$vuetify.breakpoint.mobile ? 'picto-mobile' : ''"
        class="align-self-center"
        alt="no-comparaison"
        src="@/assets/no-comparaison.svg"
      >
      <div
        :class="$vuetify.breakpoint.mobile ? 'mt-3 ml-3' : 'ml-6 align-self-center'"
      >
        <v-chip
          :color="miseAJour ? '#DBBD00' : '#EC6608'"
          label
        >
          <div class="texte white--text">
            {{ miseAJour ? 'Mise à jour' : 'Non renseigné' }}
          </div>
        </v-chip>
        <div
          v-for="(phrase, index) in phrasesIntroduction"
          :key="index"
          :class="index === 0 ? 'mt-4' : 'mt-2'"
          class="intro texte-gris-fonce"
        >
          {{ phrase }}
        </div>
      </div>
    </div>
    <v-divider class="mx-6" />
    <BaseMessageServerError v-if="!loading.init && erreur.init" />
    <BaseLoader v-if="loading.init" />
    <div v-else>
      <div class="intro texte-gris-fonce mt-6 ml-6 mr-2">
        Mon atelier cultures sur mon exploitation est :
      </div>
      <div
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
        class="flex-center mt-2 mx-6"
      >
        <v-radio-group
          v-for="(typeExploitation, index) in ateliersCultureFiltres"
          :key="index"
          v-model="parametresExploitationModifiable.typeExploitation"
          :disabled="loading.init || loadingParams"
          @change="onParamExploitationChange('typeExploitation', $event)"
        >
          <div
            :class="$vuetify.breakpoint.mobile ? '' : 'mx-2'"
            class="justify-center"
          >
            <v-radio
              :class="parametresExploitationModifiable.typeExploitation != null && parametresExploitationModifiable.typeExploitation.code === typeExploitation.code ? 'is-active' : ''"
              :label="typeExploitation.libelle"
              :value="typeExploitation"
              class="radio-button"
            />
          </div>
        </v-radio-group>
      </div>
      <v-row no-gutters>
        <v-col
          cols="12"
          md="6"
        >
          <AgrialSelect
            v-model="parametresExploitationModifiable.typeSol"
            :disabled="loading.init || loadingParams"
            :items="typesSol"
            class="mx-6 mt-3"
            item-text="libelle"
            label="Type de sol"
            required
            return-object
            @change="onParamExploitationChange('typeSol', $event)"
          />
        </v-col>
        <v-col
          v-if="hasTypeSolSelected"
          class="align-self-center"
          cols="12"
          md="6"
        >
          <div
            class="mx-6 texte texte-gris-fonce"
          >
            Profondeur d'enracinement (cm)
          </div>
          <BaseInputNumberIncrement
            :is-disabled="loading.init || loadingParams"
            :max="180"
            :min="30"
            :object-value="profondeurSol"
            :value="profondeurSol.valeur"
            class="mx-6"
            required
            @update="onParamExploitationChange('profondeurSol', $event)"
          />
        </v-col>
      </v-row>
      <v-card
        v-if="hasTypeSolSelected"
        class="mx-6 pa-4 mb-3"
        color="var(--kaki)"
        elevation="0"
      >
        <div
          :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
          class="d-flex justify-center"
        >
          <span class="action potentiel-color-text align-self-center">Indication du potentiel de sol : </span>
          <span
            :class="$vuetify.breakpoint.mobile ? 'mt-2' : ''"
            class="titre-h4 potentiel-color-text align-self-center ml-3"
          >{{ parametresExploitationModifiable.indicePotentielSol.libelle }}</span>
        </div>
      </v-card>
      <v-row no-gutters>
        <v-col
          cols="12"
          md="6"
          :class="$vuetify.breakpoint.mobile && hasTypeSolSelected ? 'mt-4' : ''"
        >
          <AgrialSelect
            v-model="parametresExploitationModifiable.typeProduction"
            :disabled="loading.init || loadingParams"
            :items="typesProduction"
            class="mx-6 mt-2"
            item-text="libelle"
            label="Type de production"
            required
            return-object
            @change="onParamExploitationChange('typeProduction', $event)"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <AgrialSelect
            v-model="parametresExploitationModifiable.ressourceEffluent"
            :disabled="loading.init || loadingParams"
            :items="ressourcesEffluent"
            class="mx-6 mt-2"
            item-text="libelle"
            label="Ressources en effluents"
            required
            return-object
            @change="onParamExploitationChange('ressourceEffluent', $event)"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col
          cols="12"
          md="6"
        >
          <AgrialSelect
            v-model="parametresExploitationModifiable.stockageCereales"
            :disabled="loading.init || loadingParams"
            :items="stockagesCereales"
            class="mx-6 mt-2"
            item-text="libelle"
            label="Stockage céréales"
            required
            return-object
            @change="onParamExploitationChange('stockageCereales', $event)"
          />
        </v-col>
        <v-col
          v-if="stockageCerealesIsPourVente"
          cols="12"
          md="6"
        >
          <AgrialInputNumber
            v-model="parametresExploitationModifiable.capaciteStockage"
            :disabled="loading.init || loadingParams"
            class="mx-6 mt-2"
            label="Capacité de stockage (en t)"
            @input="onParamExploitationChange('capaciteStockage', $event)"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import AgrialSelect from '@/components/form/agrial-select.vue'
import BaseInputNumberIncrement from '@/components/form/base-input-number-increment.vue'
import AgrialInputNumber from '@/components/form/agrial-input-number.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import {clone} from '@/utils/clone'

export default {
  name: 'ParametresExploitationFormulaire',
  components: { BaseLoader, BaseMessageServerError, AgrialInputNumber, BaseInputNumberIncrement, AgrialSelect },
  props: {
    parametresExploitation: {
      type: Object,
      required: true,
    },
    loadingParams: {
      type: Boolean,
      required: true
    },
    miseAJour: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      loading : {
        init: false,
      },
      erreur : {
        init: false,
      },
      parametresExploitationModifiable: {},
      profondeurSol: {
        valeur: null
      }
    }
  },

  computed: {
    phrasesIntroduction () {
      if (!this.miseAJour) {
        return ['Complétez vos paramètres d\'exploitation pour profiter pleinement de l\'outil.']
      }

      const consigne = 'Actualisez vos paramètres de compte pour continuer à profiter pleinement de l\'outil.'

      if (this.$vuetify.breakpoint.mobile) {
        return [consigne]
      }

      return [
        'Deux ans se sont déjà écoulés depuis la dernière mise à jour de vos paramètres d\'exploitation.',
        consigne
      ]
    },
    ...mapGetters({
      typesSol: 'parametresExploitation/parametresExploitationTypesSol',
      typesProduction: 'parametresExploitation/parametresExploitationTypesProduction',
      ressourcesEffluent: 'parametresExploitation/parametresExploitationRessourceEffluent',
      stockagesCereales: 'parametresExploitation/parametresExploitationStockageCereales',
      ateliersCulture: 'parametresExploitation/parametresExploitationAteliersCulture'
    }),
    ateliersCultureFiltres () {
      return this.ateliersCulture.filter(at=> at.code !== 'INCONNU')
    },
    hasTypeSolSelected () {
      return this.parametresExploitationModifiable.typeSol && this.parametresExploitationModifiable.typeSol.code !== 'INCONNU'
    },
    stockageCerealesIsPourVente () {
      return this.parametresExploitationModifiable.stockageCereales && this.parametresExploitationModifiable.stockageCereales.code === 'VENTE'
    },
  },

  watch: {
    parametresExploitation: {
      handler (newValue) {
        this.parametresExploitationModifiable = clone(newValue)
        this.profondeurSol.valeur = this.parametresExploitationModifiable.profondeurSol
      },
      immediate: true,
      deep: true,
    }
  },

  created () {
    this.loadInitValues()
    this.parametresExploitationModifiable = clone(this.parametresExploitation)
    this.profondeurSol.valeur = this.parametresExploitationModifiable.profondeurSol
  },

  methods: {
    ...mapActions({
      getParametresExploitationTypesSol: 'parametresExploitation/getParametresExploitationTypesSol',
      getParametresExploitationTypesProduction: 'parametresExploitation/getParametresExploitationTypesProduction',
      getParametresExploitationRessourceEffluent: 'parametresExploitation/getParametresExploitationRessourceEffluent',
      getParametresExploitationStockageCereales: 'parametresExploitation/getParametresExploitationStockageCereales',
      getParametresExploitationAteliersCulture: 'parametresExploitation/getParametresExploitationAteliersCulture',
      getParametresExploitationPotentielSol: 'parametresExploitation/getParametresExploitationPotentielSol',
      getProfondeurSolParDefaut: 'parametresExploitation/getProfondeurSolParDefaut',
    }),

    loadInitValues () {
      this.loading.init = true
      this.erreur.init = false

      Promise.all([
        this.getParametresExploitationTypesSol(),
        this.getParametresExploitationTypesProduction(),
        this.getParametresExploitationRessourceEffluent(),
        this.getParametresExploitationStockageCereales(),
        this.getParametresExploitationAteliersCulture(),
      ])
        .catch(() => this.erreur.init = true)
        .finally(() => this.loading.init = false)
    },

    loadPotentielSol () {
      this.loading.potentielSol = true
      this.erreur.potentielSol = true

      this.getParametresExploitationPotentielSol(this.parametresExploitationModifiable)
        .then(result => this.parametresExploitationModifiable.indicePotentielSol = result)
        .catch(() => this.erreur.potentielSol = true)
        .finally(() => this.loading.potentielSol = false)
    },

    async onParamExploitationChange (paramKey, newValue) {
      if (paramKey === 'profondeurSol') {
        this.parametresExploitationModifiable.profondeurSol = newValue
        this.loadPotentielSol()
      }
      if (paramKey === 'typeSol') {
        await this.getProfondeurSolParDefaut(newValue.code)
          .then((result) => {
            this.parametresExploitationModifiable.profondeurSol = result
            this.loadPotentielSol()
          })
      }

      this.$emit('change', this.parametresExploitationModifiable)
    },
  }
}
</script>

<style lang="scss" scoped>
.flex-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.picto-mobile {
  width: 72px;
}

.radio-button {
  border: 1px solid grey;
  padding: 10px 30px;
  margin-top: 3px;
  margin-right: 3px;
  border-radius: 50px;
  width: 100%;
  &.is-active  {
    border-color: var(--v-primary-base);
  }
}

.potentiel-color-text {
  color: #969A27;
}
</style>
